'use strict'
import { default as Component } from '../component.js'

class SelectCountry extends Component
{
	init()
	{
		this.setSelection()
		this.element.onchange = e =>
		{
			e.target.setAttribute('value', e.target.value)
			this.populateStateProvinces()
		}
	}

	setSelection()
	{
		if (Object.keys(App.Store.model('country')).length == 0)
			return App.Store.fetch('country', 0, { include: 'stateProvince' })
				.then(() => this.setSelection())
		if (!this.element.value)
			this.element.value = Object.values(App.Store.model('country'))[0].attributes.name
		this.populateStateProvinces()
	}

	populateStateProvinces()
	{
		const selectStateProvince = document.getElementById(this.element.getAttribute('aria-controls'))
		if (!selectStateProvince)
			return

		const selected = selectStateProvince.value || selectStateProvince.getAttribute('value')
		const selectedCountryId = this.countryIdForTwoLetterIsoCode(this.element.value)

		const optionBlank = selectStateProvince.querySelector('[value=""]').cloneNode(true)
		selectStateProvince.innerHTML = '';
		selectStateProvince.appendChild(optionBlank)
		Object.values(App.Store.model('stateprovince'))
			.filter(model => model.attributes.countryId == selectedCountryId)
			.forEach(model =>
			{
				const option = document.createElement('option')
				option.value = model.attributes.abbreviation
				option.innerText = model.attributes.name
				selectStateProvince.appendChild(option)
			})
		selectStateProvince.value = selected
		if (selected && selectStateProvince.value == '')
			selectStateProvince.value = ''
	}

	countryIdForTwoLetterIsoCode(twoLetterIsoCode)
	{
		return Object.values(App.Store.model('country'))
			.reduce((id, country) =>
			{
				if (country.attributes.twoLetterIsoCode === twoLetterIsoCode)
					return country.id
				return id
			}, 0)
	}
}

export default SelectCountry
